module.exports = __webpack_public_path__ + "img/log-out-01.72e3f087.svg";